import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { error } from 'highcharts';
import { ToasterService } from 'src/app/services/toaster.service';

import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-edit-overview-status',
  templateUrl: './edit-overview-status.component.html',
  styleUrls: ['./edit-overview-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditOverViewStatusComponent implements OnInit {
  
  headerName:string = 'Edit status';
  openEditStatus:boolean = false;
  maxLength :any = 300;
  isTextError:boolean = false;
  editOverViewStatus:string = 'statusPending';
  @Input() shipDetailsbasicinfo:any;
  @Input() editStatusDetails:any = {};
  @Output() getupdateEditStatusDetails = new EventEmitter();
  @Output() getEditStatusLoaderEvent = new EventEmitter();
  @Output() errorEditStatusLoaderEvent = new EventEmitter();
  // editStatusDetails: any = {};
  selectedStatusDateVal: any;
  statusReason: string = '';
  statusReasonError: boolean = false;
  updateEditStatusDetails: any = {};
  openDeactivateStatus: boolean = false;
  deactivateDateText: any;
  deactivateReasonText: string = '';
  deactivateReasonError: boolean = false;
  isActiveFutureReason: string = '';
  isActiveFutureDateText: any;
  isActiveFutureReasonError: boolean = false;
  editStatusPayload: { vslNumber: any; effectiveDate: string | null; reason: string; };
  selectedupComingEditStatusDate: any;
  selectedupComingEditStatusReason: string = '';
  upComingStatusDate: any;
  upComingStatusReason: string = '';
  vesselActivationDate: any;
  getFYdate: any;
  disableFYdate: any;
  upComingEditStatusReasonError: boolean = false;
  showDiscardEditBanner: boolean = false;
  discardSuccessEdit: boolean = false;
  discardEditStatusData: any;
  openDiscardEditStatus:boolean = false;
  selectedPendingStatusDate: any;
  pendingEditStatusReason: string = '';
  pendingEditStatusReasonError: boolean = false;
  openRestoreEditStatus: boolean = false;
  restoreStatusData: any;
  deactivateDisableDate: any;

  constructor(private vesselService:VesselsService, 
    private toasterService: ToasterService,
    private datePipe: DatePipe) {
  }

  ngOnInit() {
   
  }
  openEditOverViewStatus(){
    // this.getEditStatus();
    // console.log(this.shipDetailsbasicinfo)
     console.log(this.editStatusDetails);
    this.editStatusData();
  }
  clearEditSidePanelData(){
    this.editOverViewStatus = '';
    this.deactivateDateText = null;
    this.deactivateReasonText = '';
    this.deactivateReasonError = false;
    this.isActiveFutureDateText = null;
    this.isActiveFutureReason = '';
    this.selectedPendingStatusDate = null;
    this.pendingEditStatusReason = '';
    
  }
  editStatusSidePanelData(){
    this.openEditStatus = true;
    this.vesselActivationDate = this.shipDetailsbasicinfo?.vesselActivationDate;
    // this.deactivateDisableDate = new Date(this.shipDetailsbasicinfo?.vesselActivationDate);
    // console.log(this.deactivateDisableDate)
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate)
    if((this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'active') || (this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'inactive')){
      this.editOverViewStatus = 'statusActive_Inactive';
      if(this.editStatusDetails?.upcomingChange !== null && this.shipDetailsbasicinfo?.statusInfo?.futureChange === true)
      {
        this.upComingStatusDate = this.editStatusDetails?.upcomingChange?.effectiveDate;
        this.upComingStatusReason =  this.editStatusDetails?.upcomingChange?.reason;
        this.selectedupComingEditStatusDate = this.upComingStatusDate;
        this.selectedupComingEditStatusReason = this.upComingStatusReason ;
        this.showDiscardEditBanner = true;
      }
      this.selectedPendingStatusDate = new Date(this.editStatusDetails?.currentActivationDate) ?? null
      this.pendingEditStatusReason = this.editStatusDetails?.currentReason ?? ''
    }
    if(this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'pending'){
      this.editOverViewStatus = 'statusPending';
    }
    this.updateEditStatusDetails = {};
  }
  editStatusData(){
    this.clearEditSidePanelData();
    this.editStatusSidePanelData();
  }
  getEditStatus(){
    this.clearEditSidePanelData();
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getEditStatusDetails(input).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.getVesselStatusForEdit?.success){
          this.editStatusDetails = res?.data?.getVesselStatusForEdit?.data;
          this.editStatusSidePanelData();
          // this.openEditStatus = true;
          // if((this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'active') || (this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'inactive')){
          //   this.editOverViewStatus = 'statusActive_Inactive';
          //  if(this.editStatusDetails?.upcomingChange !== null && this.shipDetailsbasicinfo?.statusInfo?.futureChange === true)
          //   {
          //     this.upComingStatusDate = this.editStatusDetails?.upcomingChange?.effectiveDate;
          //     this.upComingStatusReason =  this.editStatusDetails?.upcomingChange?.reason;
          //     this.selectedupComingEditStatusDate = this.upComingStatusDate;
          //     this.selectedupComingEditStatusReason = this.upComingStatusReason ;
          //     this.showDiscardEditBanner = true;
          //   }
          // }
          // if(this.editStatusDetails?.currentStatus?.toLowerCase().trim() === 'pending'){
          //   this.editOverViewStatus = 'statusPending';
          // }
          // this.updateEditStatusDetails = {};

        }else{
          this.toasterService.openToast('Error', error);
        }
      },
      error:(error:any)=>{
         this.toasterService.openToast('Error', error);
      }
    })
  }
  
  get minSelectableDate(): Date {
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }
  selectedStatusDate(e:any){
    this.selectedStatusDateVal = e;
  }
  statusFieldValue(e:any){
    this.statusReason = e;
    if(this.statusReason.length > 300){
      this.statusReasonError = true;
    }else{
      this.statusReasonError = false;
    }
  }
  selectedActiveFutureDate(e:any){
    console.log(e)
    this.isActiveFutureDateText = e;
  }
  statusActiveFutureFieldValue(e:any){
    console.log(e)
    this.isActiveFutureReason = e;
    if(this.isActiveFutureReason.length > 300){
      this.isActiveFutureReasonError = true;
    }else{
      this.isActiveFutureReasonError = false;
    }
  }
  upComingEditStatusDate(e:any){
    this.selectedupComingEditStatusDate = e;
    this.upComingStatusDate = null;
  }
  upComingEditStatusValue(e:any){
    this.selectedupComingEditStatusReason = e;
    this.upComingStatusReason = '';
    if(this.selectedupComingEditStatusReason.length > 300){
      this.upComingEditStatusReasonError = true;
    }else{
      this.upComingEditStatusReasonError = false;
    }
  }
  pendingEditStatusDate(e:any){
    this.selectedPendingStatusDate = e;
  }
  pendingEditStatusValue(e:any){
    this.pendingEditStatusReason = e;
    if(this.pendingEditStatusReason.length > 300){
      this.pendingEditStatusReasonError = true;
    }else{
      this.pendingEditStatusReasonError = false;
    }
  }
  updateEditStatus(){
    this.getEditStatusLoaderEvent.emit();
    if(this.editOverViewStatus === 'statusPending'){
      this.editStatusPayload = {
        "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
        // "status": this.editStatusDetails?.currentStatus,
        "effectiveDate": this.datePipe.transform(this.selectedStatusDateVal,"yyyy-MM-dd") ,
        "reason": this.statusReason
      }
    }
    if(this.editOverViewStatus === 'statusActive_Inactive'){
      // ---deactivate---
      if(this.shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && this.shipDetailsbasicinfo?.statusInfo?.futureChange === false && this.shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Active'){
        this.editStatusPayload = {
          "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
          // "status": this.editStatusDetails?.currentStatus,
          // "status": 'Inactive',
          "effectiveDate": this.datePipe.transform(this.deactivateDateText,"yyyy-MM-dd") ,
          "reason": this.deactivateReasonText
        }    
      }
      // ---upcoming---
      if(this.shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false && this.shipDetailsbasicinfo?.statusInfo?.futureChange === true){
         this.editStatusPayload = {
          "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
          // "status": this.editStatusDetails?.currentStatus,
          "effectiveDate": this.datePipe.transform(this.selectedupComingEditStatusDate,"yyyy-MM-dd") ,
          "reason": this.selectedupComingEditStatusReason
        }
         
      } 
      // ----restore---
      if(this.shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && this.shipDetailsbasicinfo?.statusInfo?.futureChange === false && this.shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Inactive'){
         this.editStatusPayload = {
          "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
          // "status": this.editStatusDetails?.currentStatus,
          "effectiveDate": this.datePipe.transform(this.selectedPendingStatusDate,"yyyy-MM-dd") ,
          "reason": this.pendingEditStatusReason
        }
        
      }     
    }
    
    console.log( this.editStatusPayload)
    this.vesselService.updateEditStatus(this.editStatusPayload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.updateVesselStatus?.success){
          this.updateEditStatusDetails = res?.data?.updateVesselStatus?.data;
          this.editStatusDetails = {};
          this.getupdateEditStatusDetails.emit(this.updateEditStatusDetails);
          console.log(this.shipDetailsbasicinfo)
          // this.shipDetailsbasicinfo.statusInfo = this.updateEditStatusDetails;
          console.log("new",this.shipDetailsbasicinfo)
           this.discardSuccessEdit = false;
          this.toasterService.openToast('Success', res?.data?.updateVesselStatus?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.updateVesselStatus?.message);
          this.errorEditStatusLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error',error);
        this.errorEditStatusLoaderEvent.emit();
      }
    })
  }
  getDeactivateModal(){
    this.openDeactivateStatus = true;
    this.openEditStatus = false;
  }
  selectedDeactivateDate(e:any){
    this.deactivateDateText = e;
    console.log(e)
    
  }
  statusDeactivateFieldValue(e:any){
    this.deactivateReasonText = e;
    if(this.deactivateReasonText.length > 300){
      this.deactivateReasonError = true;
    }else{
      this.deactivateReasonError = false;
    }
  }
  getDeactivateEvent(){
    this.updateEditStatus();
  }
  discardEditStatusEvent(){
    this.openDiscardEditStatus = true;
    this.openEditStatus = false;
  }
  discardEditStatusChange(){
    this.getEditStatusLoaderEvent.emit();
    let payload = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber}
    this.vesselService.discardEditStatus(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if( res?.data?.discardVesselStatus?.success){
          this.showDiscardEditBanner = false;
          this.discardSuccessEdit = true;
          this.discardEditStatusData = res?.data?.discardVesselStatus?.data;
          this.getupdateEditStatusDetails.emit(this.discardEditStatusData);
          // this.shipDetailsbasicinfo.statusInfo = this.discardEditStatusData;
          console.log("new1",this.shipDetailsbasicinfo)
          this.toasterService.openToast('Success', res?.data?.discardVesselStatus?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.discardVesselStatus?.message);
          this.errorEditStatusLoaderEvent.emit();
        }
       
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorEditStatusLoaderEvent.emit();
      }
    })
  }
  restoreEditStatusEvent(){
    this.openRestoreEditStatus = true;
    this.openEditStatus = false;
  }
  restoreEditStatusChanges(){
    this.getEditStatusLoaderEvent.emit();
    let payload = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber}
    this.vesselService.revertEditStatusDetails(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.restoreVesselStatus?.success){
          this.restoreStatusData = res?.data?.restoreVesselStatus?.data;
          this.getupdateEditStatusDetails.emit(this.restoreStatusData);
          this.toasterService.openToast('Success', res?.data?.restoreVesselStatus?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.restoreVesselStatus?.message);
          this.errorEditStatusLoaderEvent.emit();
        }  
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorEditStatusLoaderEvent.emit();
      }
    })
  }
  cancelDeactivate(){
    this.openDeactivateStatus = false;
    this.getEditStatus();
  }
  cancelEditStatus(){
    this.statusReason = '';
    this.selectedStatusDateVal = null;
  }
  cancelDiscard(){
    this.openDiscardEditStatus = false;
    this.getEditStatus();
  }
  cancelRestoreStatus(){
    this.openRestoreEditStatus = false;
    this.getEditStatus();
  }

   
}